import React from 'react';

import {
  DatePicker as MuiXDatePicker,
  DatePickerSlotsComponentsProps,
  PickerChangeHandlerContext,
  DateValidationError
} from '@mui/x-date-pickers';
import moment, { Moment } from 'moment';
import { useTranslation } from 'react-i18next';

interface CustomDatePickerProps {
  label: string;
  id: string;
  format?: string;
  value: Moment | null;
  onChange: (value: Moment | null, context: PickerChangeHandlerContext<DateValidationError>) => void;
  className?: string;
  slotProps?: DatePickerSlotsComponentsProps<Moment>;
  minDate?: Moment;
  maxDate?: Moment;
  disabled?: boolean;
}

const DatePicker = ({
  label,
  id,
  format = moment.localeData().longDateFormat('L'),
  value,
  onChange,
  className,
  slotProps = {
    textField: {
      variant: 'standard'
    }
  },
  minDate,
  maxDate,
  disabled
}: CustomDatePickerProps) => {
  const { t } = useTranslation();

  return (
    <span id={id}>
      <MuiXDatePicker
        label={t(label)}
        format={format}
        minDate={minDate}
        maxDate={maxDate}
        value={value}
        onChange={onChange}
        className={className}
        slotProps={slotProps}
        disabled={disabled}
      />
    </span>
  );
};

export default DatePicker;
